export const Tier0UnlockAccessLockIcon = ({ color }: { color: string }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ display: 'block', flexShrink: 0, color }}>
    <path
      d="M17 10V8A5 5 0 0 0 7 8v2M12 14.5v2M8.8 21h6.4c1.68 0 2.52 0 3.16-.33a3 3 0 0 0 1.31-1.31C20 18.72 20 17.88 20 16.2v-.4c0-1.68 0-2.52-.33-3.16a3 3 0 0 0-1.31-1.31C17.72 11 16.88 11 15.2 11H8.8c-1.68 0-2.52 0-3.16.33a3 3 0 0 0-1.31 1.31C4 13.28 4 14.12 4 15.8v.4c0 1.68 0 2.52.33 3.16a3 3 0 0 0 1.31 1.31C6.28 21 7.12 21 8.8 21Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
